import { RootState } from "@/infrastructure/rootState";
import { oc } from "ts-optchain";
import * as T from "./types";

export const scrTemplateList = (state: RootState) => {
  const screener_template = state.firestore.data.screener_template;

  return screener_template ? Object.values(screener_template) : [];
};

export const portfolioList = (state: RootState): T.Portfolio[] => {
  const paper_portfolio = state.firestore.data.paper_portfolio;

  // .filter is used to handle portfolio delete case
  return paper_portfolio ? Object.values(paper_portfolio).filter(e => e) : [];
};

export const exchangeCountryMap = (state: RootState) => state.firestore.data.exchanges.exchangeCountryMapper;
export const countryExchange = (state: RootState) => oc(state.firestore.data).exchanges.info.countryExchange([]);
export const intradayData = (state: RootState) => state.firestore.data.intraday;
